import { render, staticRenderFns } from "./ReferralStatusForm.vue?vue&type=template&id=6742fde6&"
import script from "./ReferralStatusForm.vue?vue&type=script&lang=ts&"
export * from "./ReferralStatusForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralStatusForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports